// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { SkeletonElement } from "@eisinc/App/Components/Skeleton/Skeleton";
import { productImageCarouselStyles } from "@eisinc/Overrides/Components/ProductImageCarousel";
import { screen } from "@eisinc/XDL/Helpers";
import { color, hideElementOnPrint, xScreen } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

const getImageCss = (isSelected: boolean) => css`
    border: 1px solid ${isSelected ? color("secondary.main") : "transparent"};
    opacity: ${isSelected ? 1 : 0.25};
    transition: opacity 0.3s ease-in-out;
    cursor: pointer;
    justify-content: flex-start;
    &,
    img {
        aspect-ratio: 1;
    }
`;

productImageCarouselStyles.carouselSlideInner = {
    css: css`
        padding: 0;
        height: 100%;
        position: relative;
        ${xScreen("lte", "md")} {
            ${SkeletonElement} {
                width: 52px;
                min-height: 52px;
            }
        }
    `,
};

productImageCarouselStyles.carousel = {
    container: {
        css: css`
            &&&& {
                .swiper {
                    padding: 0 2px 2px 0;
                }

                .swiper-slide {
                    width: 91px;
                    height: 91px;

                    button {
                        width: 100%;
                        height: 100%;
                    }

                    ${screen("lte", "md")`
                        width: 52px;
                        height: 52px;
                    `}
                }
            }
        `,
    },
};

productImageCarouselStyles.image = {
    css: getImageCss(false),
};

productImageCarouselStyles.selectedImage = {
    css: getImageCss(true),
};

productImageCarouselStyles.carouselWrapper = {
    css: css`
        max-height: 543px;
        overflow: hidden;
        .swiper {
            height: 100%;
        }
        && {
            .swiper-vertical::before {
                top: 0;
            }
        }
        ${hideElementOnPrint}
    `,
};

productImageCarouselStyles.videoIcon = {
    css: css`
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        pointer-events: none;
        color: ${color("common.white")};
    `,
};

productImageCarouselStyles.loadingWrapper = {
    css: css`
        display: flex;
        gap: 16px;
        overflow: hidden;
        ${({ isVertical }: any) =>
            isVertical &&
            css`
                max-height: 543px;
                flex-direction: column;
            `};
    `,
};
